import { ReactElement } from 'react';

import { WaitlistEntryQuery, WaitlistEntryRemoveCommand } from '@dreryk/egabinet-waitlist-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { PromiseVoidFunction } from '@dreryk/react-common';

import { translationKeys } from '../translations';

type WaitlistEntryRemoveActionRenderProps = {
   removeEntry: PromiseVoidFunction;
};

type WaitlistEntryRemoveActionProps = {
   children: (renderProps: WaitlistEntryRemoveActionRenderProps) => ReactElement;
   entryId: number;
   onSuccess: VoidFunction;
};

export const WaitlistEntryRemoveAction = (props: WaitlistEntryRemoveActionProps): ReactElement => {
   const { executeAsync } = useCqrsCommand<void, void>(
      () => {
         const command = new WaitlistEntryRemoveCommand();
         command.id = props.entryId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(translationKeys.successfullyRemovedFromWaitlist);
            refetchCqrsQuery(WaitlistEntryQuery);
            props.onSuccess();
         },
      }
   );

   return props.children({ removeEntry: executeAsync });
};
